import React, { useEffect, useState } from "react";
import InfoBar from "../infobar/InfoBar";
import Navigation from "../navigation/Navigation";

import Register from "components/auth/register/Register";
import Login from "components/auth/login/Login";
import { useRecoilState } from "recoil";
import { loginModalState, registerModalState } from "atoms/atoms";

import "./header.scss";

function Header() {
  const [scrollY, setScrollY] = useState(0);
  const [headerHeight, setHeaderHeight] = useState(0);
  const [loginModalStateValue, setloginModalState] = useRecoilState(loginModalState);
  const [registerModalStateValue, setRegisterModalState] = useRecoilState(registerModalState);

  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setloginModalState({ isVisible: false, redirectAfterLogin: null });
      }
    };

    if (loginModalStateValue) {
      document.addEventListener("keydown", handleKeyDown);
    }

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [loginModalStateValue]);

  const toggleLoginModal = () => {
    if (loginModalStateValue.isVisible) {
      setTimeout(() => {
        setloginModalState({ isVisible: false, redirectAfterLogin: null });
      }, 300);
    } else {
      setloginModalState({ isVisible: true, redirectAfterLogin: null });
      setRegisterModalState({ isVisible: false, redirectAfterLogin: null });
    }
  };

  const toggleRegisterModal = () => {
    if (registerModalStateValue.isVisible) {
      setTimeout(() => {
        setRegisterModalState({ isVisible: false, redirectAfterLogin: null });
      }, 300);
    } else {
      setRegisterModalState({ isVisible: true, redirectAfterLogin: null });
      setloginModalState({ isVisible: false, redirectAfterLogin: null });
    }
  };

  const handleModalClose = (event) => {
    if (event.target.classList.contains("login-modal")) {
      setloginModalState({ isVisible: false, redirectAfterLogin: null });
    }

    if (event.target.classList.contains("register-modal")) {
      setRegisterModalState({ isVisible: false, redirectAfterLogin: null });
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    setHeaderHeight(document.getElementsByTagName("header")[0].clientHeight);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <header className={scrollY > headerHeight ? "fixed" : ""}>
      <InfoBar />
      <Navigation />
      {loginModalStateValue.isVisible && (
        <div className="login-modal" onClick={handleModalClose}>
          <div className="register-background" onClick={(e) => e.stopPropagation()}>
            <Login
              onClose={toggleLoginModal}
              onRegisterClick={toggleRegisterModal}
              onModalDismiss={() => setloginModalState({ isVisible: false, redirectAfterLogin: null })}
            />
          </div>
        </div>
      )}
      {registerModalStateValue.isVisible && (
        <div className="register-modal" onClick={handleModalClose}>
          <div className="register-background" onClick={(e) => e.stopPropagation()}>
            <Register
              onClose={toggleRegisterModal}
              onRegisterClick={toggleRegisterModal}
              onModalDismiss={() => setRegisterModalState({ isVisible: false, redirectAfterLogin: null })}
            />
          </div>
        </div>
      )}
    </header>
  );
}

export default Header;
